var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.836,2.011A7.46,7.46,0,0,0,3.013,7.438.681.681,0,0,0,4.326,7.8a6.112,6.112,0,0,1,6.714-4.382A6.034,6.034,0,0,1,16.274,8.4l-.4-.395a.68.68,0,1,0-.957.966L16.563,10.6a.68.68,0,0,0,.957,0l1.647-1.626a.68.68,0,1,0-.955-.966l-.563.554a7.4,7.4,0,0,0-6.436-6.5A7.619,7.619,0,0,0,9.836,2.01ZM3.712,10.168a.68.68,0,0,0-.465.195L1.6,11.989a.681.681,0,0,0,.955.97l.563-.555a7.4,7.4,0,0,0,6.436,6.5,7.485,7.485,0,0,0,8.2-5.376.681.681,0,0,0-1.313-.358,6.116,6.116,0,0,1-6.714,4.386,6.041,6.041,0,0,1-5.234-4.989l.4.395a.681.681,0,1,0,.957-.969L4.2,10.363a.68.68,0,0,0-.491-.195Z","transform":"translate(-1.397 -2)","fill":"#00008f"}));
}

Refresh.defaultProps = {"width":"18","height":"16.963","viewBox":"0 0 18 16.963"};

module.exports = Refresh;

Refresh.default = Refresh;
